<template>
  <div>
    <div class="banner">
    <img src="https://bank.giftoceanmall.com/244f6202608281537057992.png" alt="">
  </div>
  <div class="goodsList">
    <div class="xjdq">
      <!-- <div class="title xjdqtit">
      </div> -->
      <div class="goods">
        <div v-for="item in sbzq" :key="item.id" class="goods-item" @click="goDetail(item.id)">
          <div class="fenqi-tag">
            <span>{{ item.fenqi_num }}期免息</span>
          </div>
          <img :src="item.image" :alt="item.store_name">
          <div class="goods-info">
            <div class="goods-name">{{ item.store_name }}</div>
            <div class="goods-price">
              <span class="fenqi">{{ (item.price/item.fenqi_num).toFixed(2) }}/期</span>
              <span class="price">¥{{ item.price }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="shdq">
      <div class="banner">
        <img src="@assets/actimg/banner_act.png" alt="">
      </div>
      <div class="titles">
        <img :src="qtdjdImg" alt="">
      </div>
      <div class="goods">
        <div v-for="item in qtdjd" :key="item.id" class="goods-item" @click="goDetail(item.id)">
          <div class="fenqi-tag">
            <span>{{ item.fenqi_num }}期免息</span>
          </div>
          <img :src="item.image" :alt="item.store_name">
          <div class="goods-info">
            <div class="goods-name">{{ item.store_name }}</div>
            <div class="goods-price">
              <span class="fenqi">{{ (item.price/item.fenqi_num).toFixed(2) }}/期</span>
              <span class="price">¥{{ item.price }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cfdq">
      <div class="titles">
        <img :src="ghdqImg" alt="">
      </div>
      <div class="goods">
        <div v-for="item in ghdq" :key="item.id" class="goods-item" @click="goDetail(item.id)">
          <div class="fenqi-tag">
            <span>{{ item.fenqi_num }}期免息</span>
          </div>
          <img :src="item.image" :alt="item.store_name">
          <div class="goods-info">
            <div class="goods-name">{{ item.store_name }}</div>
            <div class="goods-price">
              <span class="fenqi">{{ (item.price/item.fenqi_num).toFixed(2) }}/期</span>
              <span class="price">¥{{ item.price }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cfdq">
      <div class="titles">
        <img :src="cfdqImg" alt="">
      </div>
      <div class="goods">
        <div v-for="item in cfdq" :key="item.id" class="goods-item" @click="goDetail(item.id)">
          <div class="fenqi-tag">
            <span>{{ item.fenqi_num }}期免息</span>
          </div>
          <img :src="item.image" :alt="item.store_name">
          <div class="goods-info">
            <div class="goods-name">{{ item.store_name }}</div>
            <div class="goods-price">
              <span class="fenqi">{{ (item.price/item.fenqi_num).toFixed(2) }}/期</span>
              <span class="price">¥{{ item.price }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cfdq">
      <div class="titles">
        <img :src="xjdqImg" alt="">
      </div>
      <div class="goods">
        <div v-for="item in xjdq" :key="item.id" class="goods-item" @click="goDetail(item.id)">
          <div class="fenqi-tag">
            <span>{{ item.fenqi_num }}期免息</span>
          </div>
          <img :src="item.image" :alt="item.store_name">
          <div class="goods-info">
            <div class="goods-name">{{ item.store_name }}</div>
            <div class="goods-price">
              <span class="fenqi">{{ (item.price/item.fenqi_num).toFixed(2) }}/期</span>
              <span class="price">¥{{ item.price }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="cfdq">
      <div class="titles">
        <img :src="snypImg" alt="">
      </div>
      <div class="goods">
        <div v-for="item in snyp" :key="item.id" class="goods-item" @click="goDetail(item.id)">
          <div class="fenqi-tag">
            <span>{{ item.fenqi_num }}期免息</span>
          </div>
          <img :src="item.image" :alt="item.store_name">
          <div class="goods-info">
            <div class="goods-name">{{ item.store_name }}</div>
            <div class="goods-price">
              <span class="fenqi">{{ (item.price/item.fenqi_num).toFixed(2) }}/期</span>
              <span class="price">¥{{ item.price }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
     <div class="cfdq">
      <div class="titles">
        <img :src="twpImg" alt="">
      </div>
      <div class="goods">
        <div v-for="item in twp" :key="item.id" class="goods-item" @click="goDetail(item.id)">
          <div class="fenqi-tag">
            <span>{{ item.fenqi_num }}期免息</span>
          </div>
          <img :src="item.image" :alt="item.store_name">
          <div class="goods-info">
            <div class="goods-name">{{ item.store_name }}</div>
            <div class="goods-price">
              <span class="fenqi">{{ (item.price/item.fenqi_num).toFixed(2) }}/期</span>
              <span class="price">¥{{ item.price }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
  </div>
  
</template>

<script>
import { goShopDetail } from "@libs/order";
import { getProducts, getProductClassCollection } from "@api/store";
export default {
  name: "ElectricalActivities",
  data() {
    return {
      title: "海礼网品质家电专场",
      sbzq: [],
      qtdjdImg: '',
      qtdjd:[],
      ghdqImg: '',
      ghdq:[],
      cfdqImg: '',
      cfdq:[],
      xjdqImg: '',
      xjdq:[],
      snypImg: '',
      snyp:[],
      twpImg: '',
      twp:[],
    };
  },
  mounted() {
    this.getsbzq();
    this.getqtdjd();
    this.getghdq();
    this.getcfdq();
    this.getxjdq();
    this.getsnyp();
    this.gettwp();
  },
  methods: {
    getsbzq(){
        let q = {
            id: 34,
            page: 1,
            limit: 99,
        }
        getProductClassCollection(q).then((res) => {
            this.sbzq = res.data.list;
        });
    },
    getqtdjd(){
        let q = {
            id: 35,
            page: 1,
            limit: 99,
        }
        getProductClassCollection(q).then((res) => {
            this.qtdjd = res.data.list;
            this.qtdjdImg = res.data.image;
        });
    },
    getghdq(){
        let q = {
            id: 36,
            page: 1,
            limit: 99,
        }
        getProductClassCollection(q).then((res) => {
            this.ghdq = res.data.list;
            this.ghdqImg = res.data.image;
        });
    },
    getcfdq(){
        let q = {
            id: 37,
            page: 1,
            limit: 99,
        }
        getProductClassCollection(q).then((res) => {
            this.cfdq = res.data.list;
            this.cfdqImg = res.data.image;
        });
    },
    getxjdq(){
        let q = {
            id: 38,
            page: 1,
            limit: 99,
        }
        getProductClassCollection(q).then((res) => {
            this.xjdq = res.data.list;
            this.xjdqImg = res.data.image;
        });
    },
    getsnyp(){
        let q = {
            id: 39,
            page: 1,
            limit: 99,
        }
        getProductClassCollection(q).then((res) => {
            this.snyp = res.data.list;
            this.snypImg = res.data.image;
        });
    },
    gettwp(){
        let q = {
            id: 40,
            page: 1,
            limit: 99,
        }
        getProductClassCollection(q).then((res) => {
            this.twp = res.data.list;
            this.twpImg = res.data.image;
        });
    },
    goDetail(id) {
      console.log(id);
      goShopDetail(id).then(() => {
        this.$router.push({ path: "/detail/" + id });
      });
    },
    getFenqiText(fenqi_num) {
      if (!fenqi_num) return '';
      // 如果是数字，直接作为期数
      if (typeof fenqi_num === 'number') {
        return fenqi_num + '期免息';
      }
      // 如果是字符串，提取期数
      const match = String(fenqi_num).match(/(\d+)期/);
      if (match) {
        return match[1] + '期免息';
      }
      return '';
    },
  },
}
</script>
<style scoped lang="scss">
.banner {
  width: 100%;
//   height: 7.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.15rem;
  img {
    width: 100%;
    height: 100%;
  }
}
.goodsList {
  width: 96%;
  margin: 0 auto;
  .xjdq, .shdq, .cfdq, .ghdq, .djd {
    width: 100%;
    height: auto;
    margin-bottom: 0.2rem;
    background-color: #fff;
    border: 1px solid #e5e5e5;
    
    .xjdqtit {
      width: 100%;
      background-image: url('https://bank.giftoceanmall.com/ca03e202606291956197546.jpg');
      background-size: 100%;
      height: .8rem;
    }
    .shdqtit {
      width: 100%;
      background-image: url('https://bank.giftoceanmall.com/b9033202606301116096744.jpg');
      background-size: 100%;
      height: .8rem;
    }
    .cfdqtit {
      width: 100%;
      background-image: url('https://bank.giftoceanmall.com/6c5d420260630111621539.jpg');
      background-size: 100%;
      height: .8rem;
    }
    .ghdqtit {
      width: 100%;
      background-image: url('https://bank.giftoceanmall.com/7e0ba20260630111636929.jpg');
      background-size: 100%;
      height: .8rem;
    }
    .djdtit {
      width: 100%;
      background-image: url('https://bank.giftoceanmall.com/5f793202606301116532675.jpg');
      background-size: 100%;
      height: .8rem;
    }
    .title{
      background-repeat: no-repeat;
    }

    
    .goods {
      display: flex;
      flex-wrap: wrap;
      padding: 0.1rem;
      
      .goods-item {
        width: calc(33.333% - 0.07rem);
        margin-right: 0.1rem;
        margin-bottom: 0.1rem;
        background-color: #fff;
        border-radius: 0.1rem;
        overflow: hidden;
        
        &:nth-child(3n) {
          margin-right: 0;
        }
        
        position: relative;
        
        .fenqi-tag {
          position: absolute;
          top: 0;
          right: 0;
          background: linear-gradient(135deg, #ff4444 0%, #ff0000 100%);
          color: #fff;
          font-size: 0.2rem;
          padding: 0.05rem 0.15rem;
          border-radius: 0 0.1rem 0 0.15rem;
          z-index: 10;
          font-weight: bold;
          
          span {
            display: block;
            white-space: nowrap;
          }
        }
        
        img {
          width: 100%;
          height: auto;
          display: block;
          border-radius: 0.1rem 0.1rem 0 0;
        }
        
        .goods-info {
          padding: 0.1rem;
          
          .goods-name {
            font-size: 0.24rem;
            color: #333;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            margin-bottom: 0.08rem;
            line-height: 1.4;
          }
          
          .goods-price {
            display: flex;
            align-items: baseline;
            justify-content: space-between;
            
            .fenqi {
              font-size: 0.22rem;
              color: #999;
            }
            
            .price {
              font-size: 0.32rem;
              color: #ff4444;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}
.titles{
    width:100%;
    height: auto;
    // margin-top: 0.2rem;
    img{
        width: 100%;
        height: 100%;
    }
}
</style>
